export enum BulkImportUserType {
  Summary = 'Summary',
  Upload = 'Upload',
}
